import { DatadogRUM } from '@user-portal/datadog-rum';
import { setupLogger } from '@user-portal/logger';
import NotificationsContainer from 'containers/Notifications';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import router from 'router';

import ThemeProvider from 'theme/provider';

import NetworkErrorModal from './components/Modals/NetworkErrorModal';
import { ExperimentationWrapper } from './providers';
import { initAmazonAnalytics } from './services/Analytics';
import { initAmplitude } from './services/Analytics/useAmplitude';
import { initOneTrust } from './services/OneTrust';
import { setHtmlLang } from './services/OneTrust/setHtmlLang';
import { useOneTrust } from './services/OneTrust/useOneTrust';
import Sentry from './services/Sentry/SentryInstance';
import { store } from './store/configureStore';

setupLogger({
    env: import.meta.env.ENV,
    dataDog: {
        clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
        serviceName: import.meta.env.DD_SERVICE_NAME,
        version: import.meta.env.RELEASE_DATE,
        sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
    },
});

Sentry.init();
initOneTrust(import.meta.env.ONE_TRUST_ID);
setHtmlLang();
initAmazonAnalytics();

DatadogRUM.init({
    applicationId: import.meta.env.DD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
    serviceName: import.meta.env.DD_SERVICE_NAME,
    env: import.meta.env.ENV,
    version: import.meta.env.RELEASE_DATE,
    trackingConsent: import.meta.env.ENV === 'prod' ? 'not-granted' : 'granted',
    sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
    replaySampleRate: Number(import.meta.env.DD_SESSIONREPLAY_SAMPLING_RATE) || 0,
});

function App() {
    useOneTrust({
        onConsent: () => {
            initAmplitude();
        },
    });

    return (
        <Provider store={store}>
            <ExperimentationWrapper>
                <ThemeProvider>
                    <NetworkErrorModal />
                    <NotificationsContainer />
                    <RouterProvider router={router} />
                </ThemeProvider>
            </ExperimentationWrapper>
        </Provider>
    );
}

export default App;
